import { useSyncExternalStore } from 'react';

/** DESIGN.md › Typography: the Large text preference scales every level by 150%. */
export const LARGE_TEXT_SCALE = 1.5;

/**
 * Account › Preferences › Large text. A store every screen can watch; `configureLargeText`
 * plugs the platform's storage in at the composition root (in memory only until then).
 * The `Text` component reads the resulting scale through `TextScaleProvider`.
 */
export interface LargeTextStorage {
  load(): boolean | null;
  save(enabled: boolean): void;
}

let storage: LargeTextStorage | undefined;
let enabled = false;
const listeners = new Set<() => void>();

export function configureLargeText(adapter: LargeTextStorage): void {
  storage = adapter;
  enabled = adapter.load() ?? false;
  for (const listener of listeners) listener();
}

export function setLargeText(next: boolean): void {
  if (next === enabled) return;
  enabled = next;
  storage?.save(next);
  for (const listener of listeners) listener();
}

export function getLargeText(): boolean {
  return enabled;
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** Whether the person asked for large text. */
export function useLargeText(): boolean {
  return useSyncExternalStore(subscribe, getLargeText, getLargeText);
}
